const REACT_RENDER_OP = 'ui.react.render';

const REACT_UPDATE_OP = 'ui.react.update';

const REACT_MOUNT_OP = 'ui.react.mount';

export { REACT_MOUNT_OP, REACT_RENDER_OP, REACT_UPDATE_OP };
//# sourceMappingURL=constants.js.map
